import { Card, CardContent } from "ui/components/card";

import AvatarDisplay from "components/avatar/display";
import { Badge } from "ui/components/badge";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { fullName } from "components/employee/utils";
import { ROLE_MAPPINGS } from "utils/role-format";

export function EmployeeCardContent({
  user,
  badgeContent,
  badgeClassName,
  cardProps,
  cardContent,
  info
}) {
  return (
    <Card {...cardProps}>
      <CardContent>
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between relative">
          <div className="gap-4 flex items-center">
            <AvatarDisplay className="w-10 h-10" user={user} />

            <div className="space-y-0.5">
              <h3 className="text-base font-semibold leading-6 text-card-foreground">
                {fullName(user)}
              </h3>
              <p className="text-sm font-normal leading-5 text-muted-foreground">
                {[
                  user?.user?.role?.name ||
                  user?.role?.name,
                  user?.grade?.name || user?.user?.grade?.name,
                  user?.title,
                ]
                  .filter(Boolean)
                  .join(" • ")}
              </p>
            </div>
          </div>
          {cardContent ? (
            cardContent
          ) : (
            <Badge
              className={classNames("absolute top-0 right-0", badgeClassName)}
              variant="outline"
            >
              {badgeContent || user?.department?.name || "N/A"}
            </Badge>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

export function EvtEmployeeCard({
  user,
  onClick,
  selected,
  disabled,
  className,
  badgeContent,
  badgeClassName,
  href,
  cardContent,
}) {
  const cardProps = {
    className: classNames("h-max shadow-none py-3 ", className, {
      "border-2 border-black": selected?.id === user?.id,
    }),
    onClick: disabled ? undefined : onClick,
  };

  if (href) {
    return (
      <Link to={href}>
        <EmployeeCardContent
          user={user}
          badgeContent={badgeContent}
          badgeClassName={badgeClassName}
          cardProps={cardProps}
          cardContent={cardContent}
        />
      </Link>
    );
  }

  return (
    <EmployeeCardContent
      user={user}
      badgeContent={badgeContent}
      badgeClassName={badgeClassName}
      cardProps={cardProps}
      cardContent={cardContent}
    />
  );
}
